import React from "react";
import IndependentBookingPage from "./IndependentBookingPage";
import { RouteProps } from "react-router-dom";
import withValidUserRole, { withValidUserRoleProps } from "../Auth/ProtectedPage";

interface IndependentBookingPageContainerProps extends RouteProps, withValidUserRoleProps {}

const IndependentBookingPageContainer = (props: IndependentBookingPageContainerProps) => {
    const getTitle = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "Templates" : `${path.charAt(1).toUpperCase()}${path.slice(2)}`;
    };

    const getType = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "templates" : getTitle().toLowerCase();
    };

    return <IndependentBookingPage title={getTitle()} category={getType()} />;
};

export default withValidUserRole(IndependentBookingPageContainer);
